const toDisplayDateText = (dateString: String) =>
  dateString.split('T')[0].replace(/-/g, '.')

export default toDisplayDateText
